/* eslint-disable @typescript-eslint/await-thenable */

import { createModel, RematchDispatch } from '@rematch/core';
import { AxiosResponse } from 'axios';
import { RootModel } from '.';
import { GlobalState, InternalError } from '../types';

const initialGlobalState: GlobalState = {
  error: undefined,
};

export const global = createModel<RootModel>()({
  state: initialGlobalState,
  reducers: {
    setError(state: GlobalState, error: InternalError): GlobalState {
      return {
        ...state,
        error,
      };
    },
  },
  effects: (dispatch: RematchDispatch<RootModel>) => ({
    handleError(payload: { error: any; errorMessage?: string }): void {
      if (payload.error.response) {
        const response = payload.error.response as AxiosResponse;
        this.setError({
          httpStatus: payload.error.response.status,
          message: payload.errorMessage ?? response.data?.message,
        });
      } else {
        this.setError({
          message: payload.errorMessage ?? (payload.error as Error).message,
        });
      }
    },
  }),
});
